<!-- 生产数量 -->
<template>
  <BaseFormItem
    class="number"
     :label="label || fields.label"
    :labelTips="fields.labelTips"
    isShowRequiredIcon
    :fillTips="fillTips"
    :isError="isError"
    :isErrorBlink="isErrorBlink"
    v-bind="$attrs"
  >
    <template v-if="isShowNumberType">
      <!-- 生产数量类型 -->
      <BaseRadioGroup 
        v-model="val.number_type" 
        @change="val => handleChange(val, 'number_type')"
      >
        <el-radio-button :label="1">
          {{ pcbNumber }}片全贴
        </el-radio-button>
        <el-radio-button :label="0">
          其他数量
        </el-radio-button>
      </BaseRadioGroup>
      <template v-if="val.number_type === 0">
        <i class="el-icon-minus number__separator" />
        <!-- 其他数量 -->
        <div  v-if="type==='modal'" class="input-box" >
           <BaseInput 
              v-model="val.number" 
              width="170px"
              placeholder="请输入"
              @input="val => handleEmit('number')"
              @change="handleNumberChange"
            >
              <div slot="prepend">
                输入数量
              </div>
            </BaseInput>
            <br/>
            <numberTips 
              :number = "val.number" 
              :number_type = "val.number_type" 
              :pcbNumber = "pcbNumber" 
              :units = "units" 
              :customPcbBan = "customPcbBan"
            />
        </div>
        <template v-else>
          <BaseInput 
            v-model="val.number" 
            width="170px"
            placeholder="请输入"
            @input="val => handleEmit('number')"
            @change="handleNumberChange"
          >
            <div slot="prepend">
              输入数量
            </div>
          </BaseInput>
          <div slot="other" v-if="type!=='modal'" >
              <numberTips 
                :number = "val.number" 
                :number_type = "val.number_type" 
                :pcbNumber = "pcbNumber" 
                :units = "units" 
                :customPcbBan = "customPcbBan"
              />
          </div>
        </template>
      </template>
    </template>

    <!-- 生产数量 -->
    <template v-else>
      <BaseInput
        v-model="val.number"
        width="200px"
        placeholder="生产数量"
        :max="max"
        @input="val => handleEmit('number')"
        @change="handleNumberChange"
      ></BaseInput>
      <div slot="other">
        {{ fields.unit }}
        <span class="ml-10">
            <numberTips 
              :number = "val.number" 
              :number_type = "val.number_type" 
              :pcbNumber = "pcbNumber" 
              :units = "units" 
              :customPcbBan = "customPcbBan"
            />
        </span>
      </div>
    </template>
  </BaseFormItem>
</template>

<script>
import { getSMTFields } from '@@/utils/getFields'
import { isPositiveInteger } from '@@/utils/utils'
import numberTips from "../components/numberTips.vue";
export default {
  components: {
    numberTips
  },
  props: {
    type: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    // 生产数量
    number: {
      type: [Number, String],
      default: 1
    },
    // 生产数量类型: 1-PCB数量全贴 0-其他数量
    number_type: {
      type: Number,
      default: 1
    },
    max: {
      type: [Number, String],
      default: ''
    },
    // 是否显示生产数量类型
    isShowNumberType: {
      type: Boolean,
      default: false
    },
    // PCB数量
    pcbNumber: {
      type: Number,
      default: 0
    },
    units: {
      type: [Number, String],
      default:''
    },
    customPcbBan: {
      type: [Number, String],
      default:''
    },
  },
  data() {
    return {
      val: {
        number: this.number,
        number_type: this.number_type
      },
      isError: false, // 是否显示错误提示样式
      isErrorBlink: false, // 是否显示错误提示样式且闪两下
      isUserChanged: false // 用户是否手动更改过number_type
    }
  },
  computed: {
    fields() {
      return getSMTFields('number')
    },
    // 是否显示未填写样式
    fillTips() {
      const { val, isShowNumberType} = this
      return !isShowNumberType && !val.number ? '请输入' : ''
    }
  },
  watch: {
    number(newVal) {
      this.val.number = newVal
    },
    number_type(newVal) {
      this.val.number_type = newVal
    },
  // 当pcbNumber小于number时，将number_type设置为0（其他数量）
    pcbNumber(newVal) {
      if(typeof newVal === 'number' && !isNaN(newVal) && 
         typeof this.val.number === 'number' && !isNaN(this.val.number) && 
         newVal < this.val.number&& this.isUserChanged) {
        this.val.number_type = 0;
        this.handleEmit('number_type');
        this.handleEmitChange();
      }
    }
  },
  methods: {
    handleEmit(key) {
      this.$emit(`update:${key}`, this.val[key])
      this.isShowError(false)
    },
    handleEmitChange() {
      this.$emit('change', { ...this.val })
    },
    handleChange(val, key) {
      this.val[key] = val
      this.isUserChanged = true
      this.handleEmit(key)
      this.handleEmitChange()
    },
    handleNumberChange(val,max=1000000) {
      if (isPositiveInteger(val)) {
        // 最小值 1
        val = Math.max(val, 1)
        // 最大值 1000000
        val = Math.min(val, +max)
        // 四舍五入
        val = Math.round(val)
        this.handleChange(val, 'number')
        this.isShowError(false)
      } else {
        this.handleChange('', 'number')
      }
    },
    // 是否显示错误提示样式
    isShowError(isShow, isBlink = false) {
      this.isError = isShow
      this.isErrorBlink = isBlink
    }
  }
}
</script>

<style lang="scss" scoped>
.ml-10{
  margin-left: 10px;
}
.input-box{
  display: inline-table;
}
.number {
  .number__separator {
    margin: 0 5px;
  }
  .number-tips-span{
    font-size: 12px;
    color: #E6A23C;
  }
  .number_tips {
    color: #FF4D4F;
  }
}
</style>